Ext.define('SA.view.map.menu.ApplyLocationMask', {
    alias: 'widget.map-menu-apply-location-mask',
    extend: 'SA.view.map.menu.MapMenuItem',

    text: 'Apply Location Mask',

    beforeMenuShow() {
        this.setChecked(this.getMapModel().hasLocationMask());
    },

    checkHandler(me, checked) {
        var map = me.getMapModel();

        map.setLocationMask(checked);
    }
});